import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/services/apiClient";

import type { DayRange } from "../utils/dayAxis";

export interface FollowerHistoryPoint {
  date: string;
  platform: string;
  followerCount: number;
}

const NO_POINTS: FollowerHistoryPoint[] = [];

/** The follower snapshots of every platform over `range`, oldest first. */
export const useFollowerHistory = (clientId: string, range: DayRange) => {
  // Cached per client and range, so a Followers panel open in two places
  // shares one request.
  const query = useQuery({
    queryKey: ["follower-history", clientId, range.since, range.until],
    queryFn: () =>
      apiClient.get<FollowerHistoryPoint[]>(`/api/social-media/follower-history/${clientId}`, {
        params: { start_date: range.since, end_date: range.until },
      }),
    enabled: Boolean(clientId),
  });
  const apiErr = query.error as { response?: { data?: { error?: string } }; message?: string } | null;
  const error = apiErr ? apiErr.response?.data?.error || apiErr.message || "Failed to load follower history" : null;

  return { data: query.data ?? NO_POINTS, isLoading: query.isLoading, error };
};
